import React from 'react'
import { formatCheckoutRequestStatus, formatShopDateTime } from '~/src/shared/lib/formatters'

export function CheckoutRequestsSection({ checkoutRequests, loading }) {
  return (
    <section className="account-history">
      <h2>Solicitudes de compra</h2>
      {loading ? <p>Cargando solicitudes...</p> : null}
      {!loading && checkoutRequests.length === 0 ? (
        <p>Aún no has enviado solicitudes de compra.</p>
      ) : null}
      {checkoutRequests.map((request) => (
        <article key={request.id} className="account-history__item">
          <div className="account-history__header">
            <p>Número de orden: <strong>{request.number}</strong></p>
            <p>Status: <strong>{formatCheckoutRequestStatus(request.status)}</strong></p>
          </div>
          <p>Total de la orden: <strong>${request.total_amount.toFixed(2)}</strong></p>
          <p>Fecha: <strong>{formatShopDateTime(request.submitted_at)}</strong></p>
          <div className="account-history__products">
            {request.items.map((item) => (
              <div key={`${request.id}-${item.product_id}`} className="cart-row compact">
                <span>{item.product_name} x {item.quantity}</span>
                <strong>${Number(item.total_price).toFixed(2)}</strong>
              </div>
            ))}
          </div>
        </article>
      ))}
    </section>
  )
}
